module.exports = __webpack_public_path__ + "img/2_20.1f7194ac.jpg";